import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { SearchIcon, FilterIcon, TagIcon, CalendarIcon, ClockIcon, MapPinIcon, ChevronRightIcon, CopyIcon, CheckIcon, PercentIcon, ShoppingBagIcon, CreditCardIcon, TruckIcon, CoffeeIcon, ShoppingCartIcon, HeartIcon, ThumbsUpIcon, BookOpenIcon } from 'lucide-react';
const DealsDiscounts = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [copiedCode, setCopiedCode] = useState<string | null>(null);
  const categories = [{
    id: 'all',
    name: 'All Deals',
    count: 25
  }, {
    id: 'food',
    name: 'Food & Dining',
    count: 8
  }, {
    id: 'shopping',
    name: 'Shopping',
    count: 7
  }, {
    id: 'entertainment',
    name: 'Entertainment',
    count: 5
  }, {
    id: 'travel',
    name: 'Travel',
    count: 3
  }, {
    id: 'services',
    name: 'Services',
    count: 2
  }];
  const deals = [{
    id: '1',
    title: 'Save more this weekend with Stanbic',
    description: 'Shop KES 4,000+ on the MAF Carrefour App this weekend, pay with your Stanbic Visa Debit Card & get KES 500 OFF.',
    category: 'shopping',
    merchant: 'Carrefour',
    validUntil: 'May 31, 2025',
    discount: 'KES 500 OFF',
    code: 'VISA500',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1DFpzpgtTfbZ7sAJ1ACRuM/image.png',
    featured: true,
    new: true
  }, {
    id: '2',
    title: '2 for 1 Movie Tickets',
    description: 'Buy one movie ticket and get another one free at all Anga Cinemas locations.',
    category: 'entertainment',
    merchant: 'Anga Cinemas',
    validUntil: 'June 15, 2025',
    discount: '50% OFF',
    code: 'ANGA2FOR1',
    image: '',
    featured: true
  }, {
    id: '3',
    title: '15% Off All Menu Items',
    description: 'Enjoy 15% discount on all menu items at Java House branches across Nairobi.',
    category: 'food',
    merchant: 'Java House',
    validUntil: 'May 20, 2025',
    discount: '15% OFF',
    code: 'JAVA15',
    image: ''
  }, {
    id: '4',
    title: 'KES 1,000 Off First Ride',
    description: 'New users get KES 1,000 off their first ride with Little Cab.',
    category: 'travel',
    merchant: 'Little Cab',
    validUntil: 'Ongoing',
    discount: 'KES 1,000 OFF',
    code: 'NEWRIDER',
    image: '',
    new: true
  }, {
    id: '5',
    title: '20% Off Weekend Stays',
    description: 'Book a weekend stay at any Sarova Hotel and get 20% off the regular rate.',
    category: 'travel',
    merchant: 'Sarova Hotels',
    validUntil: 'July 31, 2025',
    discount: '20% OFF',
    code: 'WEEKEND20',
    image: ''
  }, {
    id: '6',
    title: 'Buy 3 Get 1 Free',
    description: 'Purchase any 3 books and get the cheapest one free at Text Book Centre.',
    category: 'shopping',
    merchant: 'Text Book Centre',
    validUntil: 'June 30, 2025',
    discount: 'Buy 3 Get 1 Free',
    code: 'BOOK4LESS',
    image: ''
  }, {
    id: '7',
    title: '20% Off Kids & Teens Books',
    description: 'Get 20% off on all kids and teens books at Half Priced Books. The perfect opportunity to stock up on reading materials for the young ones.',
    category: 'shopping',
    merchant: 'Half Priced Books',
    validUntil: 'August 24, 2025',
    discount: '20% OFF',
    code: 'KIDS20',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tGhFbNCpjjYXFXeQD2C4Zf/image.png',
    featured: true,
    new: true
  }];
  const filteredDeals = deals.filter(deal => {
    // Category filter
    if (activeCategory !== 'all' && deal.category !== activeCategory) {
      return false;
    }
    // Search filter
    if (searchQuery && !deal.title.toLowerCase().includes(searchQuery.toLowerCase()) && !deal.description.toLowerCase().includes(searchQuery.toLowerCase()) && !deal.merchant.toLowerCase().includes(searchQuery.toLowerCase())) {
      return false;
    }
    return true;
  });
  const copyToClipboard = (code: string) => {
    navigator.clipboard.writeText(code);
    setCopiedCode(code);
    setTimeout(() => {
      setCopiedCode(null);
    }, 2000);
  };
  const getCategoryIcon = (category: string) => {
    switch (category) {
      case 'food':
        return <CoffeeIcon className="w-4 h-4" data-id="element-1493" />;
      case 'shopping':
        return <ShoppingBagIcon className="w-4 h-4" data-id="element-1494" />;
      case 'entertainment':
        return <HeartIcon className="w-4 h-4" data-id="element-1495" />;
      case 'travel':
        return <TruckIcon className="w-4 h-4" data-id="element-1496" />;
      case 'services':
        return <CreditCardIcon className="w-4 h-4" data-id="element-1497" />;
      default:
        return <TagIcon className="w-4 h-4" data-id="element-1498" />;
    }
  };
  return <div className="max-w-4xl mx-auto p-4 pt-20" data-id="element-1499">
      <div className="mb-6" data-id="element-1500">
        <h1 className="text-2xl font-bold mb-2" data-id="element-1501">Deals & Discounts</h1>
        <p className="text-gray-600 dark:text-gray-300" data-id="element-1502">
          Exclusive offers and discounts for JoinToday members across Kenya.
        </p>
      </div>
      <div className="flex flex-col md:flex-row gap-6 mb-8" data-id="element-1503">
        <div className="md:w-1/4" data-id="element-1504">
          <div className="sticky top-20" data-id="element-1505">
            <div className="mb-4" data-id="element-1506">
              <div className="relative" data-id="element-1507">
                <input type="text" placeholder="Search deals..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full p-2 pl-9 border border-gray-300 dark:border-gray-600 rounded-lg dark:bg-gray-700" data-id="element-1508" />
                <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-500 dark:text-gray-400" data-id="element-1509" />
              </div>
            </div>
            <div className="mb-4" data-id="element-1510">
              <h3 className="font-medium mb-2" data-id="element-1511">Categories</h3>
              <div className="space-y-1" data-id="element-1512">
                {categories.map(category => <button key={category.id} onClick={() => setActiveCategory(category.id)} className={`flex items-center justify-between w-full p-2 rounded-md text-left ${activeCategory === category.id ? 'bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800' : 'hover:bg-gray-100 dark:hover:bg-gray-700'}`} data-id="element-1513">
                    <div className="flex items-center" data-id="element-1514">
                      {getCategoryIcon(category.id)}
                      <span className="ml-2" data-id="element-1515">{category.name}</span>
                    </div>
                    <span className="text-xs bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 px-2 py-0.5 rounded-full" data-id="element-1516">
                      {category.count}
                    </span>
                  </button>)}
              </div>
            </div>
            <div data-id="element-1517">
              <h3 className="font-medium mb-2" data-id="element-1518">Locations</h3>
              <div className="space-y-1" data-id="element-1519">
                <button className="flex items-center justify-between w-full p-2 rounded-md text-left bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800" data-id="element-1520">
                  <span data-id="element-1521">Nairobi</span>
                  <span className="text-xs" data-id="element-1522">18</span>
                </button>
                <button className="flex items-center justify-between w-full p-2 rounded-md text-left hover:bg-gray-100 dark:hover:bg-gray-700" data-id="element-1523">
                  <span data-id="element-1524">Mombasa</span>
                  <span className="text-xs" data-id="element-1525">5</span>
                </button>
                <button className="flex items-center justify-between w-full p-2 rounded-md text-left hover:bg-gray-100 dark:hover:bg-gray-700" data-id="element-1526">
                  <span data-id="element-1527">Kisumu</span>
                  <span className="text-xs" data-id="element-1528">3</span>
                </button>
                <button className="flex items-center justify-between w-full p-2 rounded-md text-left hover:bg-gray-100 dark:hover:bg-gray-700" data-id="element-1529">
                  <span data-id="element-1530">Nakuru</span>
                  <span className="text-xs" data-id="element-1531">2</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="md:w-3/4" data-id="element-1532">
          <div className="flex justify-between items-center mb-4" data-id="element-1533">
            <h2 className="text-lg font-bold" data-id="element-1534">Featured Deals</h2>
            <button className="flex items-center text-sm border border-gray-300 dark:border-gray-600 rounded-md px-3 py-1" data-id="element-1535">
              <FilterIcon className="w-4 h-4 mr-1" data-id="element-1536" />
              Filter
            </button>
          </div>
          <div className="space-y-4 mb-8" data-id="element-1537">
            {filteredDeals.filter(deal => deal.featured).map(deal => <div key={deal.id} className="border border-gray-300 dark:border-gray-600 rounded-lg overflow-hidden" data-id="element-1538">
                  <div className="md:flex" data-id="element-1539">
                    <div className="md:w-1/3 h-48 md:h-auto bg-gray-200 dark:bg-gray-700 relative" data-id="element-1540">
                      {deal.image ? <img src={deal.image} alt={deal.title} className="w-full h-full object-cover" data-id="element-1541" /> : <div className="flex items-center justify-center h-full" data-id="element-1542">
                          <ShoppingCartIcon className="w-12 h-12 text-gray-400 dark:text-gray-500" data-id="element-1543" />
                        </div>}
                      {deal.new && <div className="absolute top-2 left-2 bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 text-xs px-2 py-1 rounded" data-id="element-1544">
                          New
                        </div>}
                    </div>
                    <div className="p-4 md:w-2/3" data-id="element-1545">
                      <div className="flex justify-between items-start" data-id="element-1546">
                        <div data-id="element-1547">
                          <h3 className="font-bold text-lg" data-id="element-1548">{deal.title}</h3>
                          <p className="text-sm text-gray-600 dark:text-gray-300 mb-2" data-id="element-1549">
                            {deal.merchant}
                          </p>
                        </div>
                        <span className="text-sm font-bold bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 px-2 py-1 rounded" data-id="element-1550">
                          {deal.discount}
                        </span>
                      </div>
                      <p className="text-sm text-gray-600 dark:text-gray-300 mb-3" data-id="element-1551">
                        {deal.description}
                      </p>
                      <div className="flex items-center text-xs text-gray-500 dark:text-gray-400 mb-4" data-id="element-1552">
                        <CalendarIcon className="w-3 h-3 mr-1" data-id="element-1553" />
                        <span data-id="element-1554">Valid until: {deal.validUntil}</span>
                      </div>
                      <div className="flex flex-wrap items-center gap-2" data-id="element-1555">
                        <div className="flex-1 min-w-0" data-id="element-1556">
                          <div className="flex items-center p-2 bg-gray-100 dark:bg-gray-700 rounded-md" data-id="element-1557">
                            <span className="mr-2 font-medium" data-id="element-1558">Code:</span>
                            <span className="font-bold" data-id="element-1559">{deal.code}</span>
                          </div>
                        </div>
                        <button onClick={() => copyToClipboard(deal.code)} className="flex items-center px-3 py-2 bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 rounded-md" data-id="element-1560">
                          {copiedCode === deal.code ? <>
                              <CheckIcon className="w-4 h-4 mr-1" data-id="element-1561" />
                              <span data-id="element-1562">Copied</span>
                            </> : <>
                              <CopyIcon className="w-4 h-4 mr-1" data-id="element-1563" />
                              <span data-id="element-1564">Copy Code</span>
                            </>}
                        </button>
                        <Link to="#" className="px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md" data-id="element-1565">
                          View Details
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>)}
          </div>
          <h2 className="text-lg font-bold mb-4" data-id="element-1566">More Deals</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1567">
            {filteredDeals.filter(deal => !deal.featured).map(deal => <div key={deal.id} className="border border-gray-300 dark:border-gray-600 rounded-lg overflow-hidden" data-id="element-1568">
                  <div className="p-4" data-id="element-1569">
                    <div className="flex justify-between items-start mb-2" data-id="element-1570">
                      <h3 className="font-bold" data-id="element-1571">{deal.title}</h3>
                      <span className="text-xs font-bold bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 px-2 py-1 rounded" data-id="element-1572">
                        {deal.discount}
                      </span>
                    </div>
                    <p className="text-sm text-gray-600 dark:text-gray-300 mb-2" data-id="element-1573">
                      {deal.merchant}
                    </p>
                    <p className="text-sm text-gray-600 dark:text-gray-300 mb-3" data-id="element-1574">
                      {deal.description}
                    </p>
                    <div className="flex items-center text-xs text-gray-500 dark:text-gray-400 mb-3" data-id="element-1575">
                      <CalendarIcon className="w-3 h-3 mr-1" data-id="element-1576" />
                      <span data-id="element-1577">Valid until: {deal.validUntil}</span>
                    </div>
                    <div className="flex flex-wrap items-center gap-2" data-id="element-1578">
                      <div className="flex-1 min-w-0" data-id="element-1579">
                        <div className="flex items-center p-2 bg-gray-100 dark:bg-gray-700 rounded-md" data-id="element-1580">
                          <span className="mr-2 font-medium" data-id="element-1581">Code:</span>
                          <span className="font-bold" data-id="element-1582">{deal.code}</span>
                        </div>
                      </div>
                      <button onClick={() => copyToClipboard(deal.code)} className="flex items-center px-3 py-1 bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 rounded-md text-sm" data-id="element-1583">
                        {copiedCode === deal.code ? <>
                            <CheckIcon className="w-3 h-3 mr-1" data-id="element-1584" />
                            <span data-id="element-1585">Copied</span>
                          </> : <>
                            <CopyIcon className="w-3 h-3 mr-1" data-id="element-1586" />
                            <span data-id="element-1587">Copy</span>
                          </>}
                      </button>
                    </div>
                  </div>
                </div>)}
          </div>
          {/* Half Priced Books Promotion - Special Highlight */}
          <div className="mt-8 mb-6 border-2 border-gray-300 dark:border-gray-600 rounded-lg overflow-hidden" data-id="element-1588">
            <div className="bg-gray-50 dark:bg-gray-800 p-4 border-b border-gray-300 dark:border-gray-600" data-id="element-1589">
              <div className="flex items-center" data-id="element-1590">
                <BookOpenIcon className="w-5 h-5 mr-2" data-id="element-1591" />
                <h3 className="font-bold text-lg" data-id="element-1592">Special Book Promotion</h3>
              </div>
            </div>
            <div className="p-6" data-id="element-1593">
              <div className="md:flex items-center gap-6" data-id="element-1594">
                <div className="md:w-1/2 mb-4 md:mb-0" data-id="element-1595">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tGhFbNCpjjYXFXeQD2C4Zf/image.png" alt="Half Priced Books Kids Sale" className="w-full h-auto rounded-lg border border-gray-300 dark:border-gray-600" data-id="element-1596" />
                </div>
                <div className="md:w-1/2" data-id="element-1597">
                  <div className="flex justify-between items-start mb-3" data-id="element-1598">
                    <h3 className="font-bold text-xl" data-id="element-1599">
                      20% Off Kids & Teens Books
                    </h3>
                    <span className="text-sm font-bold bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 px-2 py-1 rounded" data-id="element-1600">
                      20% OFF
                    </span>
                  </div>
                  <p className="text-sm text-gray-600 dark:text-gray-300 mb-2" data-id="element-1601">
                    <span className="font-medium" data-id="element-1602">Half Priced Books</span>
                  </p>
                  <p className="text-sm text-gray-600 dark:text-gray-300 mb-4" data-id="element-1603">
                    Enjoy 20% off on all kids and teens books at Half Priced
                    Books. The perfect opportunity to stock up on reading
                    materials for the young ones during the holiday season.
                  </p>
                  <div className="flex items-center text-sm text-gray-500 dark:text-gray-400 mb-4" data-id="element-1604">
                    <CalendarIcon className="w-4 h-4 mr-2" data-id="element-1605" />
                    <span data-id="element-1606">Valid from August 1st to August 24th, 2025</span>
                  </div>
                  <div className="flex flex-wrap items-center gap-3 mb-4" data-id="element-1607">
                    <div className="flex-1 min-w-0" data-id="element-1608">
                      <div className="flex items-center p-2 bg-gray-100 dark:bg-gray-700 rounded-md" data-id="element-1609">
                        <span className="mr-2 font-medium" data-id="element-1610">Promo Code:</span>
                        <span className="font-bold" data-id="element-1611">KIDS20</span>
                      </div>
                    </div>
                    <button onClick={() => copyToClipboard('KIDS20')} className="flex items-center px-3 py-2 bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 rounded-md" data-id="element-1612">
                      {copiedCode === 'KIDS20' ? <>
                          <CheckIcon className="w-4 h-4 mr-1" data-id="element-1613" />
                          <span data-id="element-1614">Copied</span>
                        </> : <>
                          <CopyIcon className="w-4 h-4 mr-1" data-id="element-1615" />
                          <span data-id="element-1616">Copy Code</span>
                        </>}
                    </button>
                  </div>
                  <div className="flex items-center" data-id="element-1617">
                    <a href="https://www.halfpricedbooks.co.ke" target="_blank" rel="noopener noreferrer" className="text-sm bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 px-4 py-2 rounded-md inline-flex items-center" data-id="element-1618">
                      Shop Now
                      <ChevronRightIcon className="w-4 h-4 ml-1" data-id="element-1619" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-6 text-center" data-id="element-1620">
            <button className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md" data-id="element-1621">
              Load More Deals
            </button>
          </div>
        </div>
      </div>
    </div>;
};
export default DealsDiscounts;